import IntroSinglePage from "../../components/IntroSinglePage";
import BannerContract from "../../components/BannerContract";
import AgentLoginComponent from "../../components/AgentLoginComponent"
import LoadImages from "../../utils/LoadImages";
import { Link, createRoutesFromChildren } from "react-router-dom";
import {useTranslation} from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../css/components/form-login.css";
import ParseHTML from "../../utils/parser";
import BackgroundImage from "../../utils/BackgroundLoadImages";
import logo from "../../../img/logo-positivo.svg";
import iconLang from "../../../img/icon_lang.svg";


function LoginPage() {

    const [t,i18n] = useTranslation("global");
    const LANG = t("lng");

    return (
      <main class="page-about">
        <section class="px-4 entry-content">
           <div style={{
                 display: 'flex',
                 justifyContent: 'center',
                 alignItems: 'flex-start',
                 paddingTop: '2rem',
               }}>
               <img style={{ padding: '5px' }}src={logo} width="211" height="53" viewBox="0 0 176 44" fill="none" xmlns="http://www.w3.org/2000/svg" />
            </div>
            <div class="grid size_6-6 max-w-site mb-8 align-center form-login"
                style={{ right: '0px', bottom: '0px' }} >
                <AgentLoginComponent />
                <p></p>
                <a className="backtosite" href={"https://www.domino-design.it/" + t("lng")} target="_blank" rel="noopener noreferrer">&#8592;&nbsp;&nbsp;{t("agentTopBar.goBackButton") }</a>
                {/*<Link className="backtosite" to={"/"+t("lng")} target="_blank"> &#8592;&nbsp;&nbsp;{t("agentTopBar.goBackButton") }</Link> -->*/}
            </div>
            <div style={{ height: '70vh', bottom: '0px' }} ></div>
        </section>
      </main>
    );
  }

 // <div class="grid size_6-6 max-w-site mb-8"></div>
export default LoginPage;